module.exports = __webpack_public_path__ + "static/img/1959_10_DanceMagazine_AnticMeet_4.9c61ba4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cage/archive/1959_10_DanceMagazine_AnticMeet_4.jpg
// module id = X5iq
// module chunks = 0